module.exports = __webpack_public_path__ + "static/img/Profit1.e71fb2b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/Profit1.gif
// module id = OWXe
// module chunks = 56